<template>
    <div class="order-container">
        <div class="order">
            <AppLoading class="loading" v-if="loading"/>
            <div class="order-wrapper" v-else>
                <div class="info-container">
                    <div class="header">
                        <span class="label">Tran ID</span>
                        <span>{{ id }}</span>

                        <AppButton
                            modifier="small-primary"
                            @click="download()"
                            :disabled="loading"
                        >
                            Download
                        </AppButton>
                    </div>
                    <div class="body">
                        <div class="column">
                            <div class="info">
                                <p class="label">Order Date</p>
                                <p class="detail">{{ order.order_date }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Customer Name</p>
                                <p class="detail capitalize">{{ order.customer_name }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Email Address</p>
                                <p class="detail">{{ order.email_address }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Contact No.</p>
                                <p class="detail">{{ order.contact_no }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Kickstarter</p>
                                <p class="detail">{{ order.kick_starter }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Voucher Code</p>
                                <p class="detail">{{ order.voucher_code | null }}</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="info">
                                <p class="label">Status</p>
                                <p class="detail">{{ order.status }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Address</p>
                                <p class="detail">{{ order.address }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Country</p>
                                <p class="detail">{{ order.country }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Zip Code</p>
                                <p class="detail">{{ order.zip_code }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Shipment Type</p>
                                <p class="detail">{{ order.shipment_type }}</p>
                            </div>

                            <div class="info">
                                <p class="label">Payment Type</p>
                                <p class="detail capitalize">{{ order.payment_type }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="receipt-container">
                    <div class="header">
                        <span>Order Details</span>
                        <span class="status">{{ order.status }}</span>
                    </div>

                    <div class="body">
                        <table>
                            <tr>
                                <th class="items">Items</th>
                                <th class="qty">Qty</th>
                                <th class="price">Unit Price</th>
                                <th class="amount">Amount</th>
                            </tr>

                            <tr v-for="(item, key) in order.order_items" :key="key">
                                <td>{{ item.name }}</td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ item.unit_price }}</td>
                                <td>{{ item.amount }}</td>
                            </tr>

                            <tr class="total-details total">
                                <td class="bold">Total Items</td>
                                <td>{{ order.order_details.total_item }}</td>
                                <td class="label">Subtotal</td>
                                <td>{{ order.order_details.sub_total }}</td>
                            </tr>

                            <tr class="total-details">
                                <td></td>
                                <td></td>
                                <td class="label">Shipping fee</td>
                                <td>{{ order.order_details.shipping_fee }}</td>
                            </tr>

                            <tr class="total-details">
                                <td></td>
                                <td></td>
                                <td class="label">Discount</td>
                                <td>{{ order.order_details.discount || '$0.00' }}</td>
                            </tr>

                            <tr class="total-details">
                                <td></td>
                                <td></td>
                                <td class="bold label">Total Amount</td>
                                <td>{{ order.order_details.total_amount }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as orderModule from '@/store/order'

export default {
	props: ['id'],

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['order/']) {
			this.$store.registerModule('order', orderModule.default)
		}
	},

    beforeRouteLeave (to, from, next) {
		if (to.name !== 'orders') {
			this.lastQueryParams = ''
		}

		next()
	},

	created () {
		this.$store.dispatch('order/viewOrder', this.id)
	},

	computed: {
		...mapFields('order', {
			order: 'orderView',
			loading: 'orderViewLoading',
            lastQueryParams: 'lastQueryParams'
		})
	},

	methods: {
		download () {
			const form = new FormData()
			form.append('transaction_id', this.id)
			this.$store.dispatch('order/downloadExcel', { form, name: this.order.customer_name })
		}
	}
}
</script>

<style lang="scss" scoped>
.order-container {
    background-color: #fff;
    width: 100%;
    height: 100%;

    .order {
        padding-left: calc(100px - 1em);
        padding-top: 5em;
        padding-bottom: 5em;
        display: flex;
        font-family: inherit;
        color: #3B4258;
        overflow: auto;

        .loading {
            margin: auto;
        }

        .order-wrapper {
            display: flex;
            width: 100%;

            .info-container {
                width: 40%;
                margin-right: 100px;

                .header {
                    display: flex;
                    padding: 10px 0px;
                    border-bottom: 1px solid #D8DEEB;

                    span {
                        font-size: 16px;
                        font-weight: 600;

                        &.label {
                            font-weight: 500;
                            margin-right: 20px;
                        }
                    }

                    button {
                        margin-left: auto;
                    }
                }

                .body {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    width: 100%;
                    padding: 20px 0px;

                    .column {
                        display: flex;
                        flex-direction: column;
                        flex-basis: 100%;
                        flex: 1;

                        .info {
                            margin-bottom: 25px;

                            .label {
                                font-size: 14px;
                                margin-bottom: 10px;
                            }

                            .detail {
                                color: #778395;
                                font-weight: 400;
                                word-break: break-word;

                                &.capitalize {
                                    text-transform: capitalize;
                                }
                            }
                        }
                    }
                }
            }

            .receipt-container {
                height: 100%;
                width: 40%;
                background-color: #FCFCFC;
                border: 1px dashed #D9DEE2;
                border-radius: 5px;
                padding: 0px 10px 20px;

                .header {
                    display: flex;
                    padding: 20px 0px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #647286;

                    .status {
                        margin-left: auto;
                    }
                }

                .body {
                    background-color: #F5F5F5;
                    padding: 10px 10px 30px;

                    table {
                        width: 100%;

                        th {
                            height: 50px;
                            font-size: 16px;
                            font-weight: 600;
                            color: #647286;
                            text-align: left;
                        }

                        td {
                            font-size: 14px;
                            color: #647286;
                            height: 55px;

                            &.bold {
                                font-weight: 600;
                                font-size: 16px;
                            }
                        }

                        .total td{
                            border-top: 1px solid #D8DEEB;
                        }

                        .total-details td{
                            height: 30px;
                            padding-top: 10px;

                            &.label {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }

    }

}
</style>
